<mat-dialog-content>
  <div class="row">
    <div class="col-6 secondary-details mb-2">
      <span *ngIf="formType === 'Create'">{{
        'address.createAddress.createAddressTitle' | translate
      }}</span>
      <span *ngIf="formType === 'Update'">{{
        'address.createAddress.updateAddressTitle' | translate
      }}</span>
      <span *ngIf="formType === 'addParties'">{{ 'shipment.lineItem.addParty' | translate }}</span>
    </div>

    <div class="col-6 text-end">
      <mat-slide-toggle
        *ngIf="isShipper && formType === 'Update'"
        (change)="defaultChange($event)"
        [checked]="isDefaultAddress"
        [disabled]="this.addressDetailsForm.invalid"
        >{{ 'address.createAddress.setAsDefault' | translate }}</mat-slide-toggle
      >
    </div>
  </div>
  <div class="row" [formGroup]="addressDetailsForm">
    <div
      *ngIf="isReceiver || addressDetailsForm.get('address_type').value == 'RECEIVER'"
      class="col-12 d-flex flex-direction-row align-items-end justify-content-end">
      <div class="d-flex mb-0 ms-4 mr-2 form-group">
        <mat-checkbox
          (change)="showHideEmailAdd($event.checked)"
          formControlName="shipmentNotification"
          class="text-wrap"
          id="checkbox">
          {{ 'address.createAddress.receiverEmailNotification' | translate }}
        </mat-checkbox>
      </div>
      <div *ngIf="showEmailAdd" class="d-flex">
        <button
          class="me-1 icon-mat-button"
          (click)="openPreAlertSetting()"
          #tooltip="matTooltip"
          matTooltip="{{ 'address.createAddress.addEmail' | translate }}"
          mat-raised-button>
          <em class="bi bi-envelope-check-fill"></em>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 form-group">
        <label class="required-field">{{ 'address.createAddress.addressType' | translate }}</label>
        <label>:</label>
        <select
          class="form-control"
          type="text"
          (change)="addressTypeChanged($event.target.value)"
          formControlName="address_type">
          <option value="">{{ 'address.createAddress.selectAddressType' | translate }}</option>
          <option class="option" *ngFor="let option of addressTypes" [value]="option">
            {{ option }}
          </option>
        </select>
        <app-error-component
          [controlName]="addressDetailsForm.get('address_type')"></app-error-component>
      </div>
      <div class="col-md-4 form-group" formGroupName="address_details">
        <label>{{ 'address.createAddress.nickName' | translate }}: </label>
        <input formControlName="NickName" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('NickName')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group" formGroupName="address_details">
        <label class="required-field">{{ 'address.createAddress.companyName' | translate }}</label
        ><label>:</label>
        <input formControlName="CompanyName" class="form-control" type="text" />
        <app-error-component
          [controlName]="addressDetailsForm.get('address_details').get('CompanyName')">
        </app-error-component>
      </div>
    </div>
    <div class="row" formGroupName="address_details">
      <div class="col-md-4 form-group">
        <label class="required-field">{{
          'address.createAddress.contactPersonName' | translate
        }}</label
        ><label>:</label>
        <input formControlName="ContactPersonName" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('ContactPersonName')
          "></app-error-component>
      </div>

      <div class="col-md-4 form-group">
        <label class="required-field">{{ 'address.createAddress.addressLine1' | translate }}</label
        ><label>:</label>
        <input formControlName="AddressLine1" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('AddressLine1')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.addressLine2' | translate }}: </label>
        <input formControlName="AddressLine2" class="form-control" type="text" />
      </div>
      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.addressLine3' | translate }}: </label>
        <input formControlName="AddressLine3" class="form-control" type="text" />
      </div>
      <div class="col-md-4 form-group address">
        <label class="required-field"
          >{{ 'address.createAddress.countryName' | translate }} :
        </label>
        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input matInput type="text" formControlName="CountryName" [matAutocomplete]="auto" />

          <mat-autocomplete
            (optionSelected)="selectionChanged($event?.option.value)"
            #auto="matAutocomplete">
            <mat-option *ngFor="let item of list" [value]="item?.name">
              {{ item?.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('CountryName')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group address">
        <label
          [ngClass]="{
            'required-field': isPostalCodeReq === true
          }"
          >{{ 'address.createAddress.postalCode' | translate }}</label
        ><label>:</label>
        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="PostalCode"
            [matAutocomplete]="autoPostalCode" />

          <mat-autocomplete #autoPostalCode="matAutocomplete">
            <mat-option
              *ngFor="let item of cityList"
              (onSelectionChange)="selectionPincodeChanged($event, item)"
              [value]="item?.postalCode">
              {{ item?.postalCode }} <span *ngIf="item?.city">,</span> {{ item?.city }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('PostalCode')
          "></app-error-component>
        <span class="msg" *ngIf="!isPostalCodeValid">{{
          'address.createAddress.invalidPostalCode' | translate
        }}</span>
      </div>
      <div class="col-md-4 form-group address">
        <label class="required-field">{{ 'address.createAddress.cityName' | translate }}</label
        ><label>:</label>
        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input matInput type="text" formControlName="CityName" [matAutocomplete]="autoCity" />

          <mat-autocomplete #autoCity="matAutocomplete">
            <mat-option
              *ngFor="let item of cityList"
              (onSelectionChange)="selectionCityChanged($event, item)"
              [value]="item?.city">
              {{ item?.city }}<span *ngIf="item?.postalCode">,</span> {{ item?.postalCode }}
              <span *ngIf="item?.cityDistrict">,</span> {{ item?.cityDistrict }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('CityName')
          "></app-error-component>
        <span class="msg" *ngIf="!isCityValid || !isAddressValidated">{{
          'address.createAddress.invalidCityName' | translate
        }}</span>
      </div>
      <div class="col-md-4 form-group">
        <label class="required-field">{{ 'address.createAddress.countryCode' | translate }}</label
        ><label>:</label>
        <input formControlName="CountryCode" readonly class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('CountryCode')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.suburb' | translate }}</label
        ><label>:</label>
        <input formControlName="suburb" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('suburb')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.provinceCode' | translate }} : </label>
        <input formControlName="ProvinceCode" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('ProvinceCode')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group">
        <label class="required-field">{{ 'address.createAddress.phone' | translate }}</label
        ><label>:</label>
        <input formControlName="Phone" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('Phone')
          "></app-error-component>
      </div>
      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.email' | translate }}: </label>
        <input formControlName="Email" class="form-control" type="text" />
      </div>

      <div class="col-md-4 form-group">
        <label>{{ 'address.createAddress.mobilePhone' | translate }}: </label>
        <input formControlName="MobilePhone" class="form-control" type="text" />
        <app-error-component
          [controlName]="
            addressDetailsForm.get('address_details').get('MobilePhone')
          "></app-error-component>
      </div>
    </div>
    <div
      *ngIf="businessTypeVal == 'SELLER' || businessTypeVal == 'BUYER'"
      class="col-md-4 form-group">
      <mat-checkbox
        color="warn"
        formControlName="businessNotification"
        class="text-wrap"
        (change)="businessNotificationClicked($event.checked)"
        id="checkbox">
        {{ businessLabel | translate }}
      </mat-checkbox>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="primary-btn me-2 text-center" mat-dialog-close="" type="button">
    {{ 'global.close' | translate }}
  </button>
  <button
    *ngIf="formType == 'Update'"
    [disabled]="
      this.addressDetailsForm.pristine ||
      this.addressDetailsForm.invalid ||
      !isPostalCodeCityValid()
    "
    class="primary-btn"
    (click)="saveAddress()">
    {{ 'global.update' | translate }}
  </button>
  <button
    *ngIf="formType == 'Create' || formType == 'addParties'"
    [disabled]="this.addressDetailsForm.invalid || !isPostalCodeCityValid()"
    class="primary-btn"
    (click)="saveAddress()">
    {{ 'global.create' | translate }}
  </button>
</mat-dialog-actions>
